import { useFormContext } from "react-hook-form";
import { Grid } from "@mui/material";
import { TTProtection } from "../../TTProtection";
import { BorderedFormGrid } from "../../../../Forms/BorderedFormGrid";
import { RHFDatePicker } from "../../../../Forms/RHFDatePicker";
import { TextFieldInput } from "../../../../Forms/TextFieldInput";
import { MdmFormProps } from "../../../../Forms/MdmFormProps";

export const TTProtectionDataForm = ({ disabledFields }: MdmFormProps) => {
  const { control } = useFormContext<TTProtection>();

  return (
    <BorderedFormGrid>
      <Grid item xs={3}>
        <RHFDatePicker control={control} name="EffectiveInDate" label="Effective In Date" />
      </Grid>
      <Grid item xs={3}>
        <TextFieldInput
          name="OverrideTT"
          control={control}
          label="Override Transit Time"
          disabledFields={disabledFields}
          type="number"
        />
      </Grid>
      <Grid item xs={3}>
        <TextFieldInput
          name="OverrideRemark"
          control={control}
          label="Override Remark"
          disabledFields={disabledFields}
        />
      </Grid>
      {/* Placeholder */}
      <Grid item xs={3} />
      <Grid item xs={3}>
        <RHFDatePicker control={control} name="EffectiveOutDate" label="Effective Out Date" />
      </Grid>
      <Grid item xs={3}>
        <TextFieldInput
          name="OverrideCode"
          control={control}
          label="Override Code"
          disabledFields={disabledFields}
        />
      </Grid>
      <Grid item xs={3} sx={{ height: "104px" }}>
        <TextFieldInput
          name="Description"
          control={control}
          disabledFields={disabledFields}
          multiline
        />
      </Grid>
    </BorderedFormGrid>
  );
};
